import { genActionMap } from '@/scripts/router';

export enum ActionKeys {
  VIEW = 'VIEW',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

const actionMap = genActionMap({
  [ActionKeys.VIEW]: {
    get title() {
      return <div>view</div>;
    },
  },
  [ActionKeys.CREATE]: {
    get title() {
      return <div>create</div>;
    },
  },
  [ActionKeys.UPDATE]: {
    get title() {
      return <div>update</div>;
    },
  },
  [ActionKeys.DELETE]: {
    get title() {
      return <div>delete</div>;
    },
  },
});

export default actionMap;
